import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const MentorRegisterComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>멘토 등록</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>멘토 등록 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default MentorRegisterComponent;
